import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useStoreActions } from '~/store/store-context';
export const useSubmitCharges = ()=>{
    const { api } = useStoreActions();
    const { mutateAsync } = useMutationState({
        mutationFn: (param)=>{
            let { relationshipId, data } = param;
            return api.billing.submitCharges(relationshipId, data);
        }
    });
    return {
        submitCharges: mutateAsync
    };
};
